export default __webpack_public_path__ + "static/media/DJ.5e87c43a.svg";